import { useNavigate } from 'react-router-dom';
import type { QuickAction } from '@/mocks/superAdminDashboard';

interface QuickActionsPanelProps {
  actions: QuickAction[];
}

const accentStyles: Record<string, { bg: string; hoverBg: string; iconBg: string; iconColor: string }> = {
  primary:   { bg: 'bg-primary-500', hoverBg: 'hover:bg-primary-600', iconBg: 'bg-background-50/20', iconColor: 'text-background-50' },
  accent:    { bg: 'bg-accent-500', hoverBg: 'hover:bg-accent-600', iconBg: 'bg-background-50/20', iconColor: 'text-background-50' },
  secondary: { bg: 'bg-secondary-500', hoverBg: 'hover:bg-secondary-600', iconBg: 'bg-background-50/20', iconColor: 'text-background-50' },
  warning:   { bg: 'bg-amber-500', hoverBg: 'hover:bg-amber-600', iconBg: 'bg-background-50/20', iconColor: 'text-background-50' },
  danger:    { bg: 'bg-red-500', hoverBg: 'hover:bg-red-600', iconBg: 'bg-background-50/20', iconColor: 'text-background-50' },
};

export default function QuickActionsPanel({ actions }: QuickActionsPanelProps) {
  const navigate = useNavigate();

  return (
    <div className="bg-background-50 border border-background-200 rounded-2xl overflow-hidden">
      {/* Header */}
      <div className="px-5 py-4 border-b border-background-200">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-background-100 flex items-center justify-center">
            <i className="ri-flashlight-line text-foreground-500 text-sm"></i>
          </div>
          <div>
            <h2 className="text-foreground-950 font-semibold text-sm">Quick Actions</h2>
            <p className="text-foreground-400 text-[10px]">Accesos rápidos del Super Admin</p>
          </div>
        </div>
      </div>

      {/* Actions grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-3 p-4">
        {actions.map((action, idx) => {
          const styles = accentStyles[action.accent];
          return (
            <button
              key={action.id}
              onClick={() => navigate(action.route)}
              className={`${styles.bg} ${styles.hoverBg} rounded-xl p-3 flex flex-col items-center gap-2 text-center cursor-pointer transition-all hover:scale-[1.02] whitespace-nowrap`}
              style={{ animation: `fadeInUp 0.3s ease-out forwards`, animationDelay: `${idx * 60}ms`, opacity: 0 }}
            >
              <div className={`w-9 h-9 rounded-lg ${styles.iconBg} flex items-center justify-center`}>
                <i className={`${action.icon} ${styles.iconColor} text-sm`}></i>
              </div>
              <span className="text-background-50 dark:text-foreground-950 text-[10px] font-bold">{action.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}